module.exports = "https://assets.pclncdn.com/web/next-landing/03c4f86f87/_next/static/images/orlando-034ac4ea085582e9e4b95abd9e392bc8.jpg";